module.exports = __webpack_public_path__ + "static/media/publicworks.49a3ace9.jpg";